import {ScorecardRow} from "./row";
import {FairwayHitRow, FairwayHitType} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";

export function getFairwayRow(row: FairwayHitRow): ScorecardRow {
    function value(fairway: FairwayHitType) {
        let classes = ""
        switch (fairway) {
            case FairwayHitType.Hit:
                classes = "fw-hit"
                break;
            case FairwayHitType.Left:
                classes = "fw-left"
                break;
            case FairwayHitType.Right:
                classes = "fw-right"
                break;
            case FairwayHitType.Long:
                classes = "fw-long"
                break;
            case FairwayHitType.Short:
                classes = "fw-short"
                break;
            case FairwayHitType.Unknown:
                break;
        }
        return `<div class='fw-cell ${classes}'></div>`
    }

    return {
        name: "Fw",
        outValues: row.data.outValues.map(fw => value(fw)),
        outTotal: row.data.outTotal != null ? "" : null,
        inValues: arrayOrEmpty(row.data.inValues).map(fw => value(fw)),
        inTotal: row.data.inTotal != null ? "" : null,
        total: "",
        classes: "fairway"
    };
}
